// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var EntryType;
(function (EntryType) {
    EntryType["UNKNOWN"] = "UNKNOWN";
    EntryType["MANUAL"] = "MANUAL";
    EntryType["CANCELATION"] = "CANCELATION";
})(EntryType || (EntryType = {}));
export var EntryType_index;
(function (EntryType_index) {
    EntryType_index[EntryType_index["UNKNOWN"] = 0] = "UNKNOWN";
    EntryType_index[EntryType_index["MANUAL"] = 1] = "MANUAL";
    EntryType_index[EntryType_index["CANCELATION"] = 2] = "CANCELATION";
})(EntryType_index || (EntryType_index = {}));
export var RequestStatus;
(function (RequestStatus) {
    RequestStatus["REQUEST_STATUS_UNKNOWN"] = "REQUEST_STATUS_UNKNOWN";
    RequestStatus["NOT_VIEWED"] = "NOT_VIEWED";
    RequestStatus["VIEWED"] = "VIEWED";
    RequestStatus["ACCEPTED"] = "ACCEPTED";
    RequestStatus["EXPIRED"] = "EXPIRED";
    RequestStatus["FAILED"] = "FAILED";
})(RequestStatus || (RequestStatus = {}));
export var RequestStatus_index;
(function (RequestStatus_index) {
    RequestStatus_index[RequestStatus_index["REQUEST_STATUS_UNKNOWN"] = 0] = "REQUEST_STATUS_UNKNOWN";
    RequestStatus_index[RequestStatus_index["NOT_VIEWED"] = 1] = "NOT_VIEWED";
    RequestStatus_index[RequestStatus_index["VIEWED"] = 2] = "VIEWED";
    RequestStatus_index[RequestStatus_index["ACCEPTED"] = 3] = "ACCEPTED";
    RequestStatus_index[RequestStatus_index["EXPIRED"] = 4] = "EXPIRED";
    RequestStatus_index[RequestStatus_index["FAILED"] = 5] = "FAILED";
})(RequestStatus_index || (RequestStatus_index = {}));
export var RequestDestinationType;
(function (RequestDestinationType) {
    RequestDestinationType["REQUEST_DESTINATION_TYPE_UNKNOWN"] = "REQUEST_DESTINATION_TYPE_UNKNOWN";
    RequestDestinationType["SMS"] = "SMS";
    RequestDestinationType["EMAIL"] = "EMAIL";
    RequestDestinationType["LINK"] = "LINK";
})(RequestDestinationType || (RequestDestinationType = {}));
export var RequestDestinationType_index;
(function (RequestDestinationType_index) {
    RequestDestinationType_index[RequestDestinationType_index["REQUEST_DESTINATION_TYPE_UNKNOWN"] = 0] = "REQUEST_DESTINATION_TYPE_UNKNOWN";
    RequestDestinationType_index[RequestDestinationType_index["SMS"] = 1] = "SMS";
    RequestDestinationType_index[RequestDestinationType_index["EMAIL"] = 2] = "EMAIL";
    RequestDestinationType_index[RequestDestinationType_index["LINK"] = 3] = "LINK";
})(RequestDestinationType_index || (RequestDestinationType_index = {}));
export var SortBy_Enum;
(function (SortBy_Enum) {
    SortBy_Enum["CREATED_AT"] = "CREATED_AT";
    SortBy_Enum["FIRST_NAME"] = "FIRST_NAME";
    SortBy_Enum["LAST_NAME"] = "LAST_NAME";
})(SortBy_Enum || (SortBy_Enum = {}));
export var SortBy_Enum_index;
(function (SortBy_Enum_index) {
    SortBy_Enum_index[SortBy_Enum_index["CREATED_AT"] = 0] = "CREATED_AT";
    SortBy_Enum_index[SortBy_Enum_index["FIRST_NAME"] = 1] = "FIRST_NAME";
    SortBy_Enum_index[SortBy_Enum_index["LAST_NAME"] = 2] = "LAST_NAME";
})(SortBy_Enum_index || (SortBy_Enum_index = {}));
export var Order_Enum;
(function (Order_Enum) {
    Order_Enum["ASC"] = "ASC";
    Order_Enum["DESC"] = "DESC";
})(Order_Enum || (Order_Enum = {}));
export var Order_Enum_index;
(function (Order_Enum_index) {
    Order_Enum_index[Order_Enum_index["ASC"] = 0] = "ASC";
    Order_Enum_index[Order_Enum_index["DESC"] = 1] = "DESC";
})(Order_Enum_index || (Order_Enum_index = {}));
export const ScheduleQuickfillService = {};
